module.exports = __webpack_public_path__ + "img/entrance_jp.a7710a5c.png";